import { MASAR } from "@/constants/testIds";
import { SectionLabel } from "@/components/masar/HowItWorks";
import { useLanguage } from "@/i18n/LanguageContext";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function Faq() {
  const { t } = useLanguage();
  const faqs = t("faq.items");
  return (
    <section
      id="faq"
      data-testid={MASAR.sectionFaq}
      className="relative py-24 sm:py-32 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionLabel index="06" label={t("faq.chapter")} />

        <div className="mt-4 grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05]">
              {t("faq.titleA")}
              <br />
              {t("faq.titleB")}
            </h2>
            <p className="mt-6 text-neutral-400 max-w-md leading-relaxed">
              {t("faq.lede")}{" "}
              <a
                href="mailto:emailsupport@masar.ltd"
                className="text-[#FF6A1A] underline decoration-2 underline-offset-4"
              >
                emailsupport@masar.ltd
              </a>
              .
            </p>
          </div>

          <div className="lg:col-span-7">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={MASAR.faqItem(i)}
                  className="border-b border-white/10"
                >
                  <AccordionTrigger className="text-left text-base sm:text-lg font-semibold py-6 hover:no-underline">
                    <span className="flex items-start gap-4">
                      <span className="font-mono text-xs text-neutral-400 mt-1.5">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span>{f.q}</span>
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="text-neutral-400 leading-relaxed pl-10 pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
